import { ArrowBack, ShoppingCart } from '@mui/icons-material';
import { Box, CircularProgress, Grid, Paper, Typography, useTheme } from '@mui/material';
import React, { useEffect } from 'react';
import GenericTable from '../common/GenericTable';
import { useParams } from 'react-router-dom';
import { orderService } from '../../services/orders';
import { addToCart, fetchCart } from '../../redux/cartSlice';
import { useDispatch } from 'react-redux';
import { useNotification } from '../../context/NotificationContext';

const OrderDetail = () => {
  const [orderData, setOrderData] = React.useState(null);
  const [isLoading, setIsLoading] = React.useState(true);
  const dispatch = useDispatch();
  const theme = useTheme();
  const { id } = useParams();
  const addNotification = useNotification();

  const getData = async () => {
    try {
      const response = await orderService.fetchOrderDetail(id);
      // console.log("order detail", response);
      if (response.status === 200) {
        setOrderData(response?.data?.data);
        setIsLoading(false);
      }
    } catch (error) {
      // console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const renderAddress = (addressString) => {
    // console.log("AS",addressString)
    const address = addressString;
    return (
      <Box>
        <Typography>{address?.address || "N/A"}</Typography>
        <Typography>Contact: {address?.contact || "N/A"}</Typography>
        <Typography>Email: {address?.email || "N/A"}</Typography>
      </Box>
    );
  };

  const columns = [
    {
      label: 'Product',
      field: 'product_name',
      render: (value, row) => {
        // Accessing the product object to get the product name
        return row.product && row.product.product_name ? row.product.product_name : "";
      }
    },
    { label: 'Unit Type', field: 'unit_type' },
    { label: 'Quantity', field: 'quantity' },
    {
      label: 'Price',
      field: 'item_price',
      render: (value, row) => {
        if (row.isSummary) {
          return <strong>{value}</strong>;
        }
        return `$${parseFloat(value || 0).toFixed(2)}`;
      }
    },
    {
      label: 'Total',
      field: 'item_total',
      render: (value, row) => {
        if (row.isSummary) {
          return <strong>{value}</strong>;
        }
        return `$${parseFloat(value || 0).toFixed(2)}`;
      }
    },
  ];
  
  useEffect(() => {
    getData();
  }, []);

  if (isLoading || !orderData) {
    return <Box
    sx={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '50vh',
      width: '100%',
      bgcolor: theme.palette.background.paper,
    }}
    >
      <CircularProgress />
    </Box>;
  }

  const { seriel, order_date, delivery_address, items, sub_total, discount, total } = orderData;

  const data = items ? items.map((item) => ({ ...item })) : [];


  const summaryData = [
    {
      product_id: '',
      unit_type: '',
      quantity: '',
      item_price: 'Sub-Total',
      item_total: sub_total,
      isSummary: true,
    },
    {
      product_id: '',
      unit_type: '',
      quantity: '',
      item_price: 'Shipping',
      item_total: discount,
      isSummary: true,
    },
    {
      product_id: '',
      unit_type: '',
      quantity: '',
      item_price: 'Total',
      item_total: total,
      isSummary: true,
    },
  ];
  const AddToCart=async (row)=>{
    // console.log('Add to cart', row)
    try {
      await dispatch(addToCart({ product_id: row?.product_id, quantity: row?.quantity }))
      const fetchCartRes=await dispatch(fetchCart());
      if(fetchCart.fulfilled.match(fetchCartRes)){
        addNotification('success', 'Added to cart successfully');
      }
    } catch (error) {
      addNotification('error', 'Error adding to cart ' + error.message);
    }
  }

  return (
    <Box sx={{ mt: 2, display: 'flex', flexDirection: 'column', gap: 4,width:"100%" }}>
      <Typography
        variant="h4"
        sx={{
          color: theme.palette.heading_color.main,
          fontWeight: 600,
          fontSize: { xs: 20, sm: 24 },
        }}
      >
        Order Information
      </Typography>

      <Paper
        elevation={2}
        sx={{
          p: 2,
          borderRadius: '5px',
          boxShadow: `0 1px 2px 0 ${theme.palette.tertiary.shadow_address}`,
          mt: 0,
          border: `1px solid ${theme.palette.secondary.light}`,
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <Typography variant="subtitle1"><strong>Order ID:</strong> #{id}</Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography variant="subtitle1"><strong>Date Added:</strong> {order_date}</Typography>
          </Grid>
        </Grid>
      </Paper>

      <Grid container spacing={3} sx={{ mb: 4 }}>
        <Grid item xs={12} sm={12}>
          <Paper
            elevation={3}
            sx={{
              p: 3,
              height: '100%',
              borderRadius: '5px',
              boxShadow: `0 1px 2px 0 ${theme.palette.tertiary.shadow_address}`,
              border: `1px solid ${theme.palette.secondary.light}`,
            }}
          >
            <Typography
              variant="h6"
              sx={{
                bgcolor: theme.palette.secondary.light,
                color: theme.palette.primary.contrastText,
                p: 1,
                mb: 2,
                borderRadius: '4px',
              }}
            >
              Shipping Address
            </Typography>
            {renderAddress(delivery_address)}
          </Paper>
        </Grid>
        
      </Grid>

      <GenericTable
        columns={columns}
        data={[...data, ...summaryData]}
        actions={[
          {
            icon: <ShoppingCart size={16} />,
            onClick: (row) => AddToCart(row),
            style: { backgroundColor: theme.palette.primary.gray, minWidth: 'unset', padding: '6px' },
          },
          // {
          //   icon: <ArrowBack size={16} />,
          //   onClick: (row) => console.log('Return', row),
          //   style: { backgroundColor: '#D9534F', minWidth: 'unset', padding: '6px' },
          // },
        ]}
        onSort={(field) => console.log('Sort by', field)}
        sortConfig={{ key: '', direction: 'asc' }}
        renderActions={(row) => !row.isSummary}
        loading={isLoading}
      />
    </Box>
  );
};

export default OrderDetail;
